/* The Mint Workshop — cart guard.
   There is no browsable cart on this store: the control goes straight to
   checkout, and only when the cart actually holds something. With an empty
   cart it explains that no cards have been submitted yet and points at the
   submission form. Fails open — if anything breaks, the link still works. */
(function () {
  'use strict';

  var modal = document.querySelector('[data-mw-guard]');
  var lastFocus = null;

  function count() {
    var n = document.querySelector('[data-mw-cart-count]');
    var v = n ? parseInt(n.textContent.trim(), 10) : NaN;
    return isNaN(v) ? 0 : v;
  }

  function open() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = modal.querySelector('a, button');
    if (f) f.focus();
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-mw-cart-link]');
    if (trigger) {
      if (count() > 0) return;              // let it through to checkout
      e.preventDefault();
      e.stopPropagation();
      open();
      return;
    }
    if (!modal) return;
    if (e.target.closest && e.target.closest('[data-mw-guard-close]')) {
      e.preventDefault();
      close();
      return;
    }
    // A link inside the modal navigates away. Close first, or the scrim is
    // left covering the destination and swallowing every click.
    var link = e.target.closest && e.target.closest('.mw-guard a[href]');
    if (link && modal.classList.contains('is-open')) close();
  }, true);

  // Client-side route changes and section reloads must also clear it
  window.addEventListener('popstate', close);
  document.addEventListener('shopify:section:load', close);

  document.addEventListener('keydown', function (e) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = modal.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

/* The Mint Workshop — submission in progress.
   If someone leaves the submission form (logo, back button) with cards in it, or their
   cart already holds a submission from the form, the header cart turns into a
   "Finish submission" button and takes them back into the form to edit and check out,
   instead of straight to checkout or the empty-cart note.
   Runs before the handlers above (window capture). Fails open: any error, normal behaviour. */
(function () {
  'use strict';
  var FORM = '/pages/submit';
  var KEY = 'mw-submit-live-v1';
  var SEL = '[data-mw-cart-link], a[href="/cart"], a[href^="/cart?"]';
  var inCart = 0;
  var other = false;   /* cart holds Pro / private client lines: leave the cart alone */

  function draftCards() {
    try {
      var j = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!j || !j.cards || !j.cards.length) return 0;
      if (j.co) return 0;   /* already sent to checkout: only what is really in the cart counts */
      return j.cards.reduce(function (a, c) { return a + (c.qty || 1); }, 0);
    } catch (e) { return 0; }
  }
  function cards() { return draftCards() || inCart; }
  function active() { return !other && cards() > 0; }

  var CSS =
    '.mw-sub-cart cart-icon,.mw-sub-cart>.svg-wrapper,.mw-sub-cart>.cart-bubble{display:none!important}' +
    '.mw-sub-cart{display:inline-flex!important;align-items:center;text-decoration:none!important}' +
    '.mw-sub-pill{display:inline-flex;align-items:center;gap:7px;height:36px;padding:0 6px 0 10px;border-radius:999px;background:#161a17;color:#fff;font:700 12px/1 Poppins,system-ui,sans-serif;letter-spacing:.02em;white-space:nowrap;box-shadow:0 0 0 0 rgba(63,122,82,.55);animation:mwSubPulse 1.6s ease-out 2}' +
    '.mw-sub-pill svg{flex:none;width:18px;height:18px}' +
    '.mw-sub-n{display:inline-grid;place-items:center;min-width:22px;height:22px;padding:0 6px;border-radius:999px;background:#a9c9ad;color:#161a17;font-weight:800;font-size:11px}' +
    '.mw-sub-cart:hover .mw-sub-pill{background:#2f6140}' +
    '@keyframes mwSubPulse{0%{box-shadow:0 0 0 0 rgba(63,122,82,.55)}100%{box-shadow:0 0 0 12px rgba(63,122,82,0)}}' +
    '@media (max-width:749px){.mw-sub-tx{display:none}.mw-sub-pill{height:32px;padding:0 5px 0 8px;gap:5px}}' +
    '@media (prefers-reduced-motion:reduce){.mw-sub-pill{animation:none}}';
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="3" width="12" height="17" rx="2"/><path d="M8 8h4M8 12h3"/><path d="M14.5 20.5l.6-2.9 5.3-5.3a1.5 1.5 0 0 1 2.1 2.1l-5.3 5.3z" fill="#161a17"/></svg>';

  function undecorate() {
    var els = document.querySelectorAll('.mw-sub-cart');
    for (var i = 0; i < els.length; i++) {
      var a = els[i], p = a.querySelector('.mw-sub-pill');
      if (p) p.parentNode.removeChild(p);
      a.classList.remove('mw-sub-cart'); a.removeAttribute('title'); a.removeAttribute('aria-label');
    }
  }

  function decorate() {
    if (!active()) { undecorate(); return; }
    if (!document.getElementById('mw-sub-css')) {
      var st = document.createElement('style'); st.id = 'mw-sub-css'; st.textContent = CSS;
      (document.head || document.documentElement).appendChild(st);
    }
    var n = cards();
    var t = 'Finish your submission (' + n + ' card' + (n > 1 ? 's' : '') + ')';
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var a = els[i];
      a.setAttribute('title', t); a.setAttribute('aria-label', t);
      a.classList.add('mw-sub-cart');
      var p = a.querySelector('.mw-sub-pill');
      if (!p) { p = document.createElement('span'); p.className = 'mw-sub-pill'; p.setAttribute('aria-hidden', 'true'); a.insertBefore(p, a.firstChild); }
      p.innerHTML = ICON + '<span class="mw-sub-tx">Finish submission</span><span class="mw-sub-n">' + n + '</span>';
    }
  }

  try {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        other = (cart.items || []).some(function (it) {
          var p = it.properties || {};
          return !!(p._bulk_entry || p._private_entry);
        });
        inCart = (cart.items || []).reduce(function (a, it) {
          var m = String((it.properties || {})._submission_meta || '').split('|');
          return a + (m[0] === 'mwproto' && m[1] === 'card' ? (it.quantity || 1) : 0);
        }, 0);
        decorate();
      })
      .catch(function () {});
  } catch (e) {}

  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(SEL);
    if (!t || !active()) return;
    if (location.pathname.indexOf('/pages/submit') === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    window.location.href = FORM;
  }, true);

  /* Header sections can re-render (cart updates, theme editor): put the button back. */
  document.addEventListener('shopify:section:load', decorate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate); else decorate();
})();
